import { createContext } from "react";

const dataContext = createContext();

export default dataContext;
